/**
 * Storefront read path for size-aware stock. `product_size_stock` is public
 * read-only, so the browser client can query it directly (RLS enforced).
 */
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { BOTTLE_SIZES, LOW_STOCK_THRESHOLD } from "./sizes";

export type ProductStockBySize = Record<string, { onHand: number; lowThreshold: number }>;

export function useProductSizeStock(productId: string | undefined) {
  const [stock, setStock] = useState<ProductStockBySize | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!productId || !/^[0-9a-f-]{36}$/i.test(productId)) {
      setStock(null);
      return;
    }
    supabase
      .from("product_size_stock")
      .select("size_ml, on_hand, low_threshold")
      .eq("product_id", productId)
      .then(({ data }) => {
        if (cancelled) return;
        const map: ProductStockBySize = {};
        for (const s of BOTTLE_SIZES) map[String(s)] = { onHand: 0, lowThreshold: LOW_STOCK_THRESHOLD };
        for (const r of data ?? []) {
          map[String(r.size_ml)] = {
            onHand: Number(r.on_hand ?? 0),
            lowThreshold: Number(r.low_threshold ?? LOW_STOCK_THRESHOLD),
          };
        }
        setStock(map);
      });
    return () => {
      cancelled = true;
    };
  }, [productId]);

  return stock;
}
